import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default function HomeIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M23.175 10.5L21 8.3265V3C21 2.175 20.325 1.5 19.5 1.5H18C17.175 1.5 16.5 2.175 16.5 3V3.8295L13.5 0.8325C13.0905 0.4455 12.7155 0 12 0C11.2845 0 10.9095 0.4455 10.5 0.8325L0.825 10.5C0.357 10.9875 0 11.343 0 12C0 12.8445 0.648 13.5 1.5 13.5H3V22.5C3 23.325 3.675 24 4.5 24H9V16.5C9 15.675 9.675 15 10.5 15H13.5C14.325 15 15 15.675 15 16.5V24H19.5C20.325 24 21 23.325 21 22.5V13.5H22.5C23.352 13.5 24 12.8445 24 12C24 11.343 23.643 10.9875 23.175 10.5Z" fill="#292929"/>
    </SvgIcon>
  );
}